import { defineStore } from "pinia";
import { useNuxtApp } from "#imports";
const setItemsQuantity = (state, { id, quantity }) => {
  const idx = state.items.findIndex((i) => i.id === id);
  if (idx > -1) {
    const update = {
      ...state.items[idx],
      id,
      quantity
    };
    state.items.splice(idx, 1, update);
  }
};
const removeCartItem = (state, id) => {
  const idx = state.items.findIndex((i) => i.id === id);
  if (idx > -1) {
    state.items.splice(idx, 1);
  }
};
export const cartStore = defineStore("cartStore", {
  state: () => ({
    items: [],
    loading: {
      putToCart: false,
      cart: false,
      updateCartItem: false,
      removeCartItem: false
    }
  }),
  actions: {
    async getCartItems() {
      try {
        const { $api } = useNuxtApp();
        this.loading.cart = true;
        const res = await $api.cartApi.getCartItems();
        this.$state.items = res;
        return res;
      } finally {
        this.loading.cart = false;
      }
    },
    async addToCart(body) {
      try {
        const { $api } = useNuxtApp();
        this.loading.putToCart = true;
        return await $api.cartApi.addItemToCart(body);
      } catch (e) {
        this.loading.putToCart = false;
        throw e.response;
      }
    },
    async removeCartItem(id) {
      try {
        const { $api } = useNuxtApp();
        this.loading.removeCartItem = true;
        const res = await $api.cartApi.removeItemFromCart(id);
        if (res) {
          removeCartItem(this.$state, id);
        }
      } finally {
        this.loading.removeCartItem = false;
      }
    },
    async updateCarItem(params) {
      try {
        const { $api } = useNuxtApp();
        this.loading.updateCartItem = true;
        const res = await $api.cartApi.updateCartItem(params.cartItemId, params);
        if (res) {
          setItemsQuantity(this.$state, {
            id: params.cartItemId,
            quantity: params.quantity
          });
          return true;
        }
        return false;
      } catch (e) {
        return false;
      } finally {
        this.loading.updateCartItem = false;
      }
    },
    async removeCartAll() {
      try {
        const { $api } = useNuxtApp();
        this.loading.removeCartItem = true;
        const res = await $api.cartApi.clearCart();
      } finally {
        this.loading.removeCartItem = false;
      }
    }
  },
  getters: {
    itemsCart: ({ items }) => items,
    getLoadingInState: ({ loading }) => loading,
    totalSum: ({ items }) => items.reduce((sum, item) => sum + item.price * item.quantity, 0),
    itemsCount: ({ items }) => items.reduce((count, item) => count + item.quantity, 0)
  }
});
